
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';

import ModFrameBox from '../content/mod-frame-box.vue';

import ModFrameFlowChart from '../frames/01-mod-frame-flow-chart.vue';
import ModFrameMoleculeOverview from '../frames/02-mod-frame-molecule-overview.vue';
import ModFrameManyMolecules from '../frames/03-mod-frame-many-molecules.vue';
import ModFrameEnterBody from '../frames/04-mod-frame-enter-body.vue';
import ModFrameVirusEntry from '../frames/09-mod-frame-virus-entry.vue';
import ModFrameVirusInfusion from '../frames/10-mod-frame-virus-infusion.vue';
import ModFrameVirusRna from '../frames/11-mod-frame-virus-rna.vue';
import ModFrameBreakdown from '../frames/12-mod-frame-breakdown.vue';
import ModFrameEncoded from '../frames/13-mod-frame-encoded-protease-v2.vue';
import ModFrameMutagenesis from '../frames/14-mod-frame-mutagenesis.vue';
import ModFrameRnaReplication from '../frames/15-mod-frame-rna-replication.vue';
import ModFrameMembrane from '../frames/18-mod-frame-membrane.vue';
import ModFrameVitaminRelease from '../frames/19-mod-frame-vitamin-release.vue';
import ModFrameVitaminExit from '../frames/20-mod-frame-vitamin-exit.vue';
import ModCredits from '../frames/21-mod-credits.vue';


export default defineComponent({
	components: {
		ModFrameBox,
		ModFrameFlowChart,
		ModFrameMoleculeOverview,
		ModFrameManyMolecules,
		ModFrameEnterBody,
		ModFrameVirusEntry,
		ModFrameVirusInfusion,
		ModFrameVirusRna,
		ModFrameBreakdown,
		ModFrameEncoded,
		ModFrameMutagenesis,
		ModFrameRnaReplication,
		ModFrameMembrane,
		ModFrameVitaminRelease,
		ModFrameVitaminExit,
		ModCredits
	},
	props: {
		datum: {
			type: Array,
			required: true,
		},
		ready: {
			type: Boolean,
			default: false,
		}
	},
	setup() {
		const store = useStore();

		// Computed active frame
		const activeFrame = computed((): string => store.getters.get_activeFrame);

		return { activeFrame }
	},
})
